import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { DatesSelectionType } from '../Types';
import { calendarConfig } from 'Components/Constants';
import { ArrowContainer, ArrowLeft, ArrowRight, Month, MonthContainer, MonthWrapper } from 'Components/Calendar/MonthSelectorComponents';
import { useDebouncedCallback } from "use-debounce";

type MonthSelectorProps = {
    datesSelection: DatesSelectionType;
    setMonth(month: number): void;
    setYear(year: number): void;
}
function MonthSelector({ datesSelection, setMonth, setYear }: MonthSelectorProps) {
    const [focusYear, setFocusYear] = useState<number>(moment().year());
    const [focusMonth, setFocusMonth] = useState<number>(moment().month());
    
    const allMonths: string[] = moment.monthsShort();
    const maxSelectableDate = moment().startOf('month').add(calendarConfig.maxSearchableMnthsRng - 1, "month"); // subtracting 1 allows up to end of 12th month to be selected
    const maxSelectableMonth =  moment(maxSelectableDate).month();
    const maxSelectableYear =  moment(maxSelectableDate).year();

    useEffect(() => {
        var month = focusMonth;
        var year = focusYear;

        if (datesSelection.start_date && datesSelection.end_date) {
            year = moment(datesSelection.start_date).year();
            month = moment(datesSelection.start_date).month();
            setFocusYear(year);
            setFocusMonth(month);
        }

        setMonth(month);
        setYear(year);

    }, []);

    const toggleMonth = useDebouncedCallback((direction: number) => {
        var month: number = focusMonth + direction;
        var year: number = focusYear;

        if (month == 12) {
            month = 0;
            year = year + 1;
        }

        if (month == -1) {
            month = 11;
            year = year - 1;
        }
        setFocusMonth(month);
        setFocusYear(year);
        
        setMonth(month);
        setYear(year);
    }, 200);

    return (
        <MonthContainer>
            <ArrowContainer>
                {!(focusMonth == moment().month() && focusYear == moment().year()) &&
                    <ArrowLeft onClick={() => toggleMonth(-1)} />
                }
            </ArrowContainer>
            <MonthWrapper>
                <Month>{allMonths[focusMonth] + " " + focusYear}</Month>
            </MonthWrapper>
            <ArrowContainer>
                {!(focusYear == maxSelectableYear && focusMonth == maxSelectableMonth) &&
                    <ArrowRight onClick={() => toggleMonth(1)} />
                }
            </ArrowContainer>
            
        </MonthContainer>

    );
}
export default MonthSelector;
